const ERROR_PAGE_CODES = [403, 404] as const;

export type ErrorPageCode = (typeof ERROR_PAGE_CODES)[number];

const errorPageCodeValues: readonly unknown[] = ERROR_PAGE_CODES;

export function isErrorPageCode(value: unknown): value is ErrorPageCode {
  return errorPageCodeValues.includes(value);
}
